const FIELD_LABELS = {
  username: '用户名',
  password: '密码',
  email: '邮箱',
  first_name: '姓名',
  last_name: '姓氏',
  student_no: '学号',
  role: '角色',
  group: '用户组',
  group_id: '用户组',
  google_email: 'Google 邮箱',
  google_calendar_id: 'Google 日历 ID',
  wecom_user_id: '企业微信成员 UserID',
  wecom_external_userid: '企微客户ID/微信号',
  whatsapp_phone: 'WhatsApp 手机号',
  language: '语言环境',
  timezone: '时区',
  study_status: '学习状态',
  valid_until: '有效期',
  is_active: '状态',
  non_field_errors: '提交内容',
};

const MESSAGE_TRANSLATIONS = {
  'A user with that username already exists.': '该用户名已被使用，请换一个',
  'user with this username already exists.': '该用户名已被使用，请换一个',
  'Enter a valid email address.': '请输入有效的邮箱地址',
  'Ensure this field has at least 8 characters.': '长度至少 8 位',
  'Ensure this field has at least 6 characters.': '长度至少 6 位',
  'This field may not be blank.': '不能为空',
  'This field is required.': '不能为空',
};

function translateMessage(text) {
  const normalized = String(text || '').trim();
  if (!normalized) return '';
  return MESSAGE_TRANSLATIONS[normalized] || normalized;
}

function isHtmlErrorResponse(text) {
  const normalized = String(text || '').trim().toLowerCase();
  return normalized.startsWith('<!doctype') || normalized.startsWith('<html');
}

function normalizeStringError(text, status, fallback) {
  if (isHtmlErrorResponse(text)) {
    if (status >= 500) return '服务器内部错误，请稍后重试或联系管理员';
    return fallback;
  }
  return translateMessage(text) || fallback;
}

function collectErrorParts(data, parts = []) {
  if (!data || typeof data !== 'object') {
    return parts;
  }

  if (Array.isArray(data)) {
    data.forEach((item) => collectErrorParts(item, parts));
    return parts;
  }

  Object.entries(data).forEach(([key, value]) => {
    if (key === 'detail' || key === 'message') return;

    const label = FIELD_LABELS[key] || key;

    if (Array.isArray(value)) {
      if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null && !Array.isArray(value[0])) {
        value.forEach((item) => collectErrorParts(item, parts));
        return;
      }
      const text = value.map((item) => translateMessage(item)).filter(Boolean).join('，');
      if (text) parts.push(`${label}：${text}`);
      return;
    }

    if (typeof value === 'object' && value !== null) {
      collectErrorParts(value, parts);
      return;
    }

    const text = translateMessage(value);
    if (text) parts.push(`${label}：${text}`);
  });

  return parts;
}

/**
 * 将 DRF / Axios 错误响应格式化为用户可理解的中文提示。
 */
export function formatApiError(error, fallback = '操作失败') {
  if (!error) return fallback;

  if (error.errorFields?.length) {
    const first = error.errorFields[0];
    const fieldLabel = FIELD_LABELS[first.name?.[0]] || '表单';
    const fieldMsg = first.errors?.[0];
    if (fieldMsg) return `${fieldLabel}：${fieldMsg}`;
  }

  if (!error.response) {
    if (error.request) return '网络请求失败，请检查网络连接';
    return error.message || fallback;
  }

  const { status, data } = error.response;

  if (status === 401) return '未登录或登录已过期，请重新登录';
  if (status === 403) return '没有权限执行此操作';
  if (status === 404) return '请求的资源不存在';
  if (status >= 500) return '服务器内部错误，请稍后重试或联系管理员';

  if (!data) return fallback;
  if (typeof data === 'string') return normalizeStringError(data, status, fallback);

  if (data.detail) {
    if (Array.isArray(data.detail)) {
      return data.detail.map((item) => translateMessage(item)).join('；') || fallback;
    }
    return translateMessage(data.detail) || fallback;
  }

  if (data.message) {
    return translateMessage(data.message) || fallback;
  }

  const parts = collectErrorParts(data, []);
  if (parts.length > 0) {
    return parts.join('；');
  }

  return fallback;
}
